<template>
  <div class="container">
    <div v-if="!hasChildren">


      <!-- HEADER -->
      <div class="header row p-0 m-0">
        <div class="col-12 col-lg-6 p-0 m-0">
          <img :src="`${publicPath}img/mutua21-24.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
        </div>
        <div class="col-12 col-lg-6 text-start p-5 pt-4  pb-0">
          <h1 class="text-blue mt-0 mb-0">{{ $t('planestrategico.plan') }}<br>{{ $t('planestrategico.la_mutua') }}</h1>
          <p>{{ $t('planestrategico.el_nuevo_plan') }}</p>
        </div>
      </div>
      <!-- end HEADER -->

      <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">
        <div class="row">
          <h2 class="my-5">{{ $t('planestrategico.proceso') }}</h2>
          <div class="col-12 col-lg-6 text-start pe-5" v-html="$t('planestrategico.el_plan')">
          </div>
          <div class="col-12 col-lg-6">
            <h3>{{ $t('planestrategico.definicion') }}</h3>
            <div class="container border border-light p-3 m-0" data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-inversiones">
              <div class="row align-items-top">
                <div class="col-12 col-lg-5 pt-3">
                  <h2 class="p-0 m-0"><AnimatedNumber
                      ref='counter_grupos'
                      :startAmount='0'
                      :endAmount='13'
                      :duration='3'
                      prefix=''
                      suffix=''
                      :separator=separator
                      :decimalSeparator=decimal_separator
                      :decimals='0'
                      :autoinit='true'
                      @finished='counterFinished'
                  /></h2>
                  <p class="textSmall">{{ $t('planestrategico.grupos') }}</p>
                </div>
                <div class="col-12 col-lg-2">
                  <img :src="`${publicPath}img/Grupo 1033.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive mb-3">
                </div>
                <div class="col-12 col-lg-5 pt-3">
                  <h2 class="p-0 m-0"><AnimatedNumber
                      ref='counter_profesionales'
                      :startAmount='0'
                      :endAmount='85'
                      :duration='3'
                      prefix=''
                      suffix=''
                      :separator=separator
                      :decimalSeparator=decimal_separator
                      :decimals='0'
                      :autoinit='true'
                      @finished='counterFinished'
                  /></h2>
                  <p class="textSmall">{{ $t('planestrategico.profesionales') }}</p>
                </div>
              </div>
            </div>
            <hr class="filigrana">
          </div>
        </div>
      </section>


      <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">
        <div class="g-0 p-0 m-0">
          <h2 class="my-5">{{ $t('planestrategico.pilares') }}</h2>
          <h4 class="text-black"><strong>{{ $t('planestrategico.plan_21') }}</strong></h4>
            <div class="row align-items-top mb-5" id="accordion">
              <div class="col-12 col-lg-3 pt-3 pt-lg-0 accordion-item accordion-header" id="heading01">
                <h1 class="p-0 m-0">1.</h1>
                <div class="cercleGris">
                  <div class="cercleBlue">
                    {{ $t('planestrategico.medicina') }}
                  </div>
                </div>
                <div class="row">
                  <a data-bs-toggle="collapse" data-bs-target="#collapse01" aria-expanded="true" aria-controls="collapse01" class="text-end btnPlus"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></a>
                </div>
                <div id="collapse01" class="accordion-collapse collapse" aria-labelledby="heading01">
                  <hr class="filigranaLine">
                  <div class="accordion-bodyPlan text-black text-start position-relative">
                    <p>{{ $t('planestrategico.un_modelo') }}</p>
                    <p class="position-absolute bottom-0 pe-3 myriadPro"><strong>{{ $t('planestrategico.experta') }}</strong></p>
                  </div>
                  <hr class="filigranaRed mb-0 pb-0">
                </div>
              </div>
              <div class="col-12 col-lg-3 pt-3 pt-lg-0 accordion-item accordion-header" id="heading02">
                <h1 class="p-0 m-0">2.</h1>
                <div class="cercleGris">
                  <div class="cercleBlue">
                    {{ $t('planestrategico.aceleracion') }}
                  </div>
                </div>
                <div class="row">
                  <a data-bs-toggle="collapse" data-bs-target="#collapse02" aria-expanded="true" aria-controls="collapse02" class="text-end btnPlus"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></a>
                </div>
                <div id="collapse02" class="accordion-collapse collapse" aria-labelledby="heading02">
                  <hr class="filigranaLine">
                  <div class="accordion-bodyPlan text-black text-start position-relative">
                    <p>{{ $t('planestrategico.impulso') }}</p>
                    <p class="position-absolute bottom-0 pe-3 myriadPro text-start"><strong>{{ $t('planestrategico.procesos_negocio') }}</strong></p>
                  </div>
                  <hr class="filigranaRed mb-0 pb-0">
                </div>
              </div>
              <div class="col-12 col-lg-3 pt-3 pt-lg-0 accordion-item accordion-header" id="heading03">
                <h1 class="p-0 m-0">3.</h1>
                <div class="cercleGris">
                  <div class="cercleBlue">
                    {{ $t('planestrategico.agentes_activos') }}
                  </div>
                </div>
                <div class="row">
                  <a data-bs-toggle="collapse" data-bs-target="#collapse03" aria-expanded="true" aria-controls="collapse03" class="text-end btnPlus"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></a>
                </div>
                <div id="collapse03" class="accordion-collapse collapse" aria-labelledby="heading03">
                  <hr class="filigranaLine">
                  <div class="accordion-bodyPlan pe-0 text-black text-start position-relative" v-html="$t('planestrategico.foco')"></div>
                  <hr class="filigranaRed mb-0 pb-0">
                </div>
              </div>
              <div class="col-12 col-lg-3 pt-3 pt-lg-0 accordion-item accordion-header" id="heading04">
                <h1 class="p-0 m-0">4.</h1>
                <div class="cercleGris">
                  <div class="cercleBlue">
                    {{ $t('planestrategico.cultura') }}
                  </div>
                </div>
                <div class="row">
                  <a data-bs-toggle="collapse" data-bs-target="#collapse04" aria-expanded="true" aria-controls="collapse04" class="text-end btnPlus"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></a>
                </div>
                <div id="collapse04" class="accordion-collapse collapse" aria-labelledby="heading04">
                  <hr class="filigranaLine">
                  <div class="accordion-bodyPlan text-black text-start position-relative" v-html="$t('planestrategico.basado')"></div>
                  <hr class="filigranaRed mb-0 pb-0">
                </div>
              </div>
              <div class="row g-0 mt-5">
                <a class="text-center btnPlus" href="https://youtu.be/3YDtU_rn9BE" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive"> {{ $t('literals.vervideo') }}</a>
              </div>

            </div>


          <h3>{{ $t('planestrategico.desarrollo_del_plan') }}</h3>
          <h4 class="text-black"><strong>{{ $t('planestrategico.cada_pilar') }}</strong></h4>
          <div class="container border border-light p-3 m-0" data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-equipos">
            <div class="row align-items-start">
              <div class="col-12 col-lg-3 px-0 px-lg-5 mb-5 mb-lg-0">
                <h2><AnimatedNumber
                    ref='counter_responsables'
                    :startAmount='0'
                    :endAmount='4'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="text-black">{{ $t('planestrategico.responsables') }}</p>
              </div>
              <div class="col-12 col-lg-3 px-0 px-lg-5 mb-5 mb-lg-0">
                <h2><AnimatedNumber
                    ref='counter_equipos'
                    :startAmount='0'
                    :endAmount='28'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="text-black">{{ $t('planestrategico.equipos') }}</p>
              </div>
              <div class="col-12 col-lg-3 px-0 px-lg-5 mb-5 mb-lg-0">
                <h2><AnimatedNumber
                    ref='counter_profesionales_2'
                    :startAmount='0'
                    :endAmount='160'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="text-black">{{ $t('planestrategico.profesionales') }}</p>
              </div>
              <div class="col-12 col-lg-3 px-0 px-lg-5 mb-5 mb-lg-0">
                <h2><AnimatedNumber
                    ref='counter_no_participo'
                    :startAmount='0'
                    :endAmount='70'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="text-black">{{ $t('planestrategico.no_participo') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana">


        </div>
      </section>


      <!-- NAVEGACIÓ PRE-FOOTER -->
      <hr>
      <div class="row p-0 g-0 mb-3">
        <div class="col-6 p-0 m-0 pb-3 text-start">
          <localized-link class="footerLink" to="/cartas"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.cartas") }}</localized-link>
        </div>
        <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
          <localized-link class="footerLink" to="/nuestra-actuacion-en-2021"> {{ $t("nav.nuestra-actuacion-en-2021") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
        </div>
      </div>


    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  props: {
    hasChildren: Boolean
  },
  components: {
    AnimatedNumber
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ','
    }
  },
  mounted() {

    document.addEventListener('aos:in:start-counter-inversiones', this.startCounterInversiones);
    document.addEventListener('aos:in:start-counter-equipos', this.startCounterEquipos);

    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounterInversiones() {
      if (this.$refs.counter_grupos != null) {
        this.$refs.counter_grupos.start();
      }
      if (this.$refs.counter_profesionales != null) {
        this.$refs.counter_profesionales.start();
      }
    },
    startCounterEquipos() {
      if (this.$refs.counter_responsables != null) {
        this.$refs.counter_responsables.start();
      }
      if (this.$refs.counter_equipos != null) {
        this.$refs.counter_equipos.start();
      }
      if (this.$refs.counter_profesionales_2 != null) {
        this.$refs.counter_profesionales_2.start();
      }
      if (this.$refs.counter_no_participo != null) {
        this.$refs.counter_no_participo.start();
      }

    },
    onReady() {
      this.$refs.youtube.playVideo()
    },
  }
}
</script>
